import { Controller } from "@hotwired/stimulus"

/**
 * Construction drawing pipeline shell helpers.
 * Stage navigation is owned by cd-shell; this controller handles deep links
 * and hash changes without scrolling the page.
 */
export default class extends Controller {
  connect() {
    this.boundOnHash = this.onHashChange.bind(this)
    window.addEventListener("hashchange", this.boundOnHash)
    if (window.location.hash) {
      requestAnimationFrame(() => this.scrollToHash(window.location.hash))
    }
  }

  disconnect() {
    window.removeEventListener("hashchange", this.boundOnHash)
  }

  onHashChange() {
    this.scrollToHash(window.location.hash)
  }

  scrollToHash(hash) {
    const id = (hash || "").replace(/^#/, "")
    if (!id) return
    this.openStage(id)
  }

  openStage(raw) {
    const stage = this.normalizeStage(raw)
    const shell = this.application.getControllerForElementAndIdentifier(this.element, "cd-shell")
    if (shell && typeof shell.show === "function") {
      shell.show(stage)
      return
    }
    // Fallback if shell not connected yet
    this.element.querySelectorAll("[data-cd-shell-target='panel']").forEach((panel) => {
      const on = panel.dataset.stage === stage
      panel.hidden = !on
    })
  }

  normalizeStage(raw) {
    const s = String(raw || "sheets").replace(/^stage-/, "")
    if (s === "sheets" || s === "scope" || s === "identify") return "sheets"
    if (s === "legends" || s === "legend" || s === "catalog") return "legends"
    if (s === "ingest" || s === "detect" || s === "analysis") return "detect"
    if (s === "symbols" || s === "review") return "review"
    if (s === "takeoff" || s === "results" || s === "markup") return "takeoff"
    return s
  }

}
